import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from '../util/common-util';
import { SurveyAnswerReminderDialogComponent } from '../dialog/survey-answer-reminder-dialog/survey-answer-reminder-dialog.component';
import { SurveyListResponse } from '../model/survey';
import { Constant } from '../constant';

// 回答受付期間中、当月分が未回答のアンケート対象者にだけ表示するリマインダーポップアップ。
// 表示要否の判定（対象月かどうか・対象者かどうか・未回答かどうか）は一覧取得APIの結果を
// そのまま使うことで、ページ遷移のたびに現在の役職・回答状況で判定し直す（キャッシュしない）
@Injectable({ providedIn: 'root' })
export class SurveyAnswerReminderService {
  private readonly dialogId = 'surveyAnswerReminder';
  private apiPath = '/survey/list';

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private commonUtil: CommonUtil,
  ) {}

  check(): void {
    // 権限なし（未承認）のアカウントには表示しない
    if (!this.auth.hasAuth(3)) {
      return;
    }

    Auth.currentSession().then(session => {
      const options = this.auth.createApiHeader(session);
      const path = `${this.apiPath}?page=0&size=1`;

      this.commonUtil.apiGet(path, options)
        .then(res => {
          const data: SurveyListResponse = res.data;
          const item = data.viewType === 'member' ? data.memberItems[0] : null;
          // 担当に職場/店舗（最小分類）を含まない場合は表示しない（担当がまるごとブランクなら表示する）
          if (item && item.status === 'unanswered' && data.hasLeafWorkplace) {
            this.show(item.rawMonth);
          }
        })
        .catch(err => {
          this.commonUtil.debug().log(err);
        });
    }).catch(() => {});
  }

  private show(rawMonth: string): void {
    if (this.dialog.getDialogById(this.dialogId)) {
      return;
    }
    const month = Number(rawMonth.split('-')[1]);

    const dialogRef = this.dialog.open(SurveyAnswerReminderDialogComponent, {
      width: Constant.surveyAnswerReminderDialogWidth,
      autoFocus: false,
      id: this.dialogId,
      data: { month },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigateByUrl('/survey/answer');
      }
    });
  }
}
